/** Pins light-theme fixes after lazy screen CSS loads */
const STYLE_ID = "kuber-light-pin";

export function ensurePremiumStyles() {
  if (typeof document === "undefined") return;
  let el = document.getElementById(STYLE_ID);
  if (!el) {
    el = document.createElement("style");
    el.id = STYLE_ID;
    el.textContent = `
      .kuber-sidebar, .fixedSider { background: #fff !important; }
      .kuber-sidebar-user-avatar { width: 36px !important; height: 36px !important; border-radius: 50%; object-fit: cover; }
      .ant-menu.kuber_leftbar_menu li svg .b { fill: none !important; stroke: #9ca3af; }
      .k-entity-list__name { color: #111827 !important; }
      .k-page-header__title { color: #111827 !important; }
    `;
    document.head.appendChild(el);
  } else {
    document.head.appendChild(el);
  }
}
